import type { MobilityAd } from "@mobility-item-page/types";
import { hasHomeDelivery } from "src/utils/safetyElements.ts";

type Props = {
  ad?: MobilityAd;
};
const HomeDelivery = ({ ad }: Props) => {
  if (ad && hasHomeDelivery(ad)) {
    return <p className="mb-0 whitespace-pre-line">{ad.home_delivery?.description}</p>;
  }
};

export default HomeDelivery;
